import axios from 'axios';
import qs from 'qs';
import { getCsrfToken } from '../utils/GeneralUtils';

const ChronusApi = {
  getUrlJS (url, data) {
    return this._requestUrl(url, data, 'get', 'application/javascript').then((response) => {
      // eslint-disable-next-line no-eval
      eval(response.data) // Bad idea. This code is used only for transition purposes. TODO Remove once transistion is finished.
    });
  },

  getUrlJSON (url, data) {
    return this._requestUrl(url, data, 'get', 'application/json').then((response) => {
      return response.data;
    });
  },

  postUrlJS(url, data, headers = {}) {
    return this._requestUrl(url, data, 'post', 'application/javascript', { headers }).then((response) => {
      // eslint-disable-next-line no-eval
      eval(response.data); // Bad idea. This code is used only for transition purposes. TODO Remove once transistion is finished.
    });
  },

  postUrlJSON(url, data) {
    return this._requestUrl(url, data, 'post', 'application/json');
  },

  patchUrlJS(url, data, headers = {}) {
    return this._requestUrl(url, data, 'patch', 'application/javascript', { headers }).then((response) => {
      // eslint-disable-next-line no-eval
      eval(response.data); // Bad idea. This code is used only for transition purposes. TODO Remove once transistion is finished.
    });
  },

  patchUrlJSON(url, data) {
    return this._requestUrl(url, data, 'patch', 'application/json');
  },

  deleteUrlJS(url, data) {
    return this._requestUrl(url, data, 'delete', 'application/javascript');
  },

  deleteUrlJSON(url, data) {
    return this._requestUrl(url, data, 'delete', 'application/json');
  },

  getUrlCSV(url, data) {
    return this._requestUrl(url, data, 'get', 'text/csv').then((response) => {
      this._downloadFile(response, 'text/csv', 'export.csv');
    });
  },

  postUrlPDF(url, data) {
    return this._requestUrl(url, data, 'post', 'application/json', { responseType: 'blob' }).then((response) => {
      this._downloadFile(response, 'application/pdf', 'export.pdf');
    });
  },

  _downloadFile(response, contentType, defaultFileName) {
    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    const fileName = this._getFileNameFromResponse(response) || defaultFileName;

    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  },

  _getFileNameFromResponse(response) {
    const contentDisposition = response.headers['content-disposition'];
    if (!contentDisposition || contentDisposition.indexOf('attachment') === -1) return null;

    // Prefer RFC 5987 `filename*=UTF-8''...` so non-ASCII characters (pseudo-locale
    // output, accented names) are preserved; fall back to ASCII `filename="..."`.
    return this._parseUtf8FileName(contentDisposition) || this._parseAsciiFileName(contentDisposition);
  },

  _parseUtf8FileName(contentDisposition) {
    const match = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
    if (!match || !match[1]) return null;
    try {
      return decodeURIComponent(match[1]);
    } catch (_e) {
      return null;
    }
  },

  _parseAsciiFileName(contentDisposition) {
    const match = /filename="([^"]*)"/.exec(contentDisposition);
    return match && match[1] ? match[1] : null;
  },

  _requestUrl(url, data, method, accept, options) {
    const { headers: extraHeaders, ...extraConfig } = options || {};
    let randomCode = Math.floor(Math.random() * Math.floor(2000)).toString();
    let paramObj = this._getDefaultParams(url, method, accept, randomCode, extraHeaders || {});
    if(method.toLowerCase() === 'get') {
      paramObj = {
        ...paramObj,
        ...{
          params: this._getDataJSON(data),
          paramsSerializer: this._serialize
        }
      }
    }
    else {
      paramObj = {
        ...paramObj,
        ...{
          data: this._getDataJSON(data)
        }
      }
    }
    paramObj = { ...paramObj, ...extraConfig };
    return axios(paramObj).then((data) => {
      if(!!document.getElementById(randomCode)) {
        document.getElementById(randomCode).remove();
      }
      return data;
    })
  },

  _getDefaultParams (url, method, accept, randomCode, headers = {}) {
    return {
      url: url,
      method: method,
      onDownloadProgress: (progressEvent) => {
        this._progressHandler(randomCode)
      },
      onUploadProgress: (progressEvent) => {
        this._progressHandler(randomCode)
      },

      headers: Object.assign({
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': accept,
        'Accept': accept,
        'X-CSRF-Token': getCsrfToken()
      }, headers)
    }
  },

  _serialize (params) {
    return qs.stringify(params, {
      arrayFormat: 'brackets'
    })
  },

  _getDataJSON (data) {
    if(Object.prototype.toString.call(data) === '[object String]')
      return this._convertDataToJSON(data);
    return data;
  },

  _convertDataToJSON (data) {
    let paramEntries = new URLSearchParams(data).entries();
    let result = {}
    for(let entry of paramEntries) {
      const [key, value] = entry;
      result[key] = value;
    }
    return result;
  },

  _getDelay(delayMs, attempt) {
    if (typeof delayMs === 'function') return delayMs(attempt);
    if (Array.isArray(delayMs)) return delayMs[attempt - 1] ?? delayMs[delayMs.length - 1];
    return delayMs;
  },

  // Polls a JSON endpoint until `isReady(response)` returns true or attempts are exhausted.
  // Supports fixed, array-scheduled, or function-based delays. Returns { promise, cancel }.
  // Options: isReady (required), delayMs, maxTries, onExhausted.
  pollUrlJSON(url, data, { isReady, delayMs = 2000, maxTries, onExhausted } = {}) {
    if (typeof isReady !== 'function') {
      throw new Error('pollUrlJSON: isReady must be a function');
    }

    const resolvedMaxTries = maxTries ?? (Array.isArray(delayMs) ? delayMs.length : 5);
    let attempt = 0;
    let timeoutId = null;
    let cancelled = false;

    const promise = new Promise((resolve, reject) => {
      const poll = () => {
        this.getUrlJSON(url, data)
          .then((response) => {
            if (cancelled) return;

            if (isReady(response)) {
              resolve(response);
              return;
            }

            attempt++;
            if (attempt >= resolvedMaxTries) {
              if (onExhausted) onExhausted();
              resolve(response);
              return;
            }

            timeoutId = setTimeout(poll, this._getDelay(delayMs, attempt));
          })
          .catch((error) => {
            if (cancelled) return;
            if (onExhausted) onExhausted(error);
            reject(error);
          });
      };

      poll();
    });

    const cancel = () => {
      cancelled = true;
      if (timeoutId) clearTimeout(timeoutId);
    };

    return { promise, cancel };
  },

  _progressHandler (randomCode) {
    if(!document.getElementById(randomCode)) {
      let newdiv = document.createElement("div");
      newdiv.id = randomCode
      newdiv.classList = "ccu-request-in-progress hide"
      newdiv.appendChild(document.createTextNode(""));
      document.body.appendChild(newdiv);
    }
  }
}

export default ChronusApi;
